// ================= DASHBOARD =================
export const DASHBOARD_START = 'DASHBOARD_START';
export const DASHBOARD_SUCCESS = 'DASHBOARD_SUCCESS';
export const DASHBOARD_FAILED = 'DASHBOARD_FAILED';

// ================= USER PLANS =================
export const USER_PLANS_START = 'USER_PLANS_START';
export const USER_PLANS_SUCCESS = 'USER_PLANS_SUCCESS';
export const USER_PLANS_FAILED = 'USER_PLANS_FAILED';
export const USER_PLANS_RESET = 'USER_PLANS_RESET';

// ================= INITIAL DASHBOARD =================
export const INITIAL_USER_DASHBOARD_START = 'INITIAL_USER_DASHBOARD_START';
export const INITIAL_USER_DASHBOARD_SUCCESS = 'INITIAL_USER_DASHBOARD_SUCCESS';
export const INITIAL_USER_DASHBOARD_FAILED = 'INITIAL_USER_DASHBOARD_FAILED';

// ================= SUBSCRIPTION =================
export const USER_SUBSCRIPTION_START = 'USER_SUBSCRIPTION_START';
export const USER_SUBSCRIPTION_SUCCESS = 'USER_SUBSCRIPTION_SUCCESS';
export const USER_SUBSCRIPTION_FAILED = 'USER_SUBSCRIPTION_FAILED';

// ================= UI MESSAGES =================
export const USER_DASHBOARD_SUCCESS_MESSAGE = 'USER_DASHBOARD_SUCCESS_MESSAGE';
export const USER_DASHBOARD_ERROR_MESSAGE = 'USER_DASHBOARD_ERROR_MESSAGE';
export const CLEAR_USER_DASHBOARD_MESSAGE = 'CLEAR_USER_DASHBOARD_MESSAGE';

// ================= LEGACY / OPTIONAL =================
export const CHANGE_SUBSCRIBER = 'CHANGE_SUBSCRIBER';
